import {useLayoutEffect, useRef} from 'react';

type Callback<Args extends unknown[], Result> = (...args: Args) => Result;

/**
 * React hook to persist a callback between renders while keeping its
 * implementation up to date.
 */
export function useCallbackRef<Args extends unknown[], Result>(
  fn: Callback<Args, Result> | undefined
) {
  const fnRef = useRef(fn);
  const callbackRef = useRef((...args: Args) => fnRef.current?.(...args));

  useLayoutEffect(() => {
    fnRef.current = fn;
  });

  return callbackRef.current;
}
